import { useRef, useState } from 'react';
import Button from '../ui/Button';

type Props = {
  title: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  confirmText?: string;
  isLoading?: boolean;
};

const Alert = ({
  title,
  onConfirm,
  onClose,
  confirmText = 'Confirm',
  isLoading = false,
}: Props) => {
  const [internalLoading, setInternalLoading] = useState(false);
  const inFlight = useRef(false);
  const loading = isLoading || internalLoading;

  const handleConfirm = async () => {
    if (inFlight.current || loading) {
      return;
    }
    inFlight.current = true;
    setInternalLoading(true);
    try {
      await onConfirm();
    } finally {
      inFlight.current = false;
      setInternalLoading(false);
    }
  };

  return (
    <>
      <div
        className="w-full h-[1800px] absolute top-0 left-0 bottom-0 right-0 bg-secondary-main opacity-70 z-50"
        onClick={loading ? undefined : onClose}
      />
      <div className="flex flex-col items-center fixed w-fit md:max-w-[500px] h-fit p-6 bg-white rounded-xl z-[60] top-0 left-0 right-0 bottom-0 m-auto">
        <h1 className="text-xl text-secondary-main mb-9">{title}</h1>
        <div className="flex w-full">
          <Button
            text={confirmText}
            onClick={handleConfirm}
            disabled={loading}
            showLoader={loading}
          />
          <Button
            className="ml-6"
            styleType="secondary"
            text="Cancel"
            disabled={loading}
            onClick={onClose}
          />
        </div>
      </div>
    </>
  );
};

export default Alert;
